import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import MirrorImage from "../../../../../Images/mirror_app_logo.png";
import ClanImage from "../../../../../Images/clan_logo (1).png";
import SyncImage from "../../../../../Images/sync-logo.png";
import LenseImage from "../../../../../Images/lense.png";
import BackIcon from "../../../../../Images/backIcon.png";
import HomeIcon from "../../../../../Images/homeIcon.png";

const ProductsConfiguration = ({
  accountName,
  roleName,
  roleId,
  accountId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showPopup, setShowPopup] = useState(false);
  const [inputType, setInputType] = useState(null);


  const incomingState = location?.state || {};

  const safeRoleId =
    roleId ??
    incomingState?.roleId ??
    incomingState?.adminRoleId ??
    null;

  const safeAccountId =
    accountId ??
    incomingState?.accountId ??
    incomingState?.adminClientId ??
    null;

  const safeAccountName =
    accountName ??
    incomingState?.accountName ??
    incomingState?.clientName ??
    "";

  const safeRoleName =
    roleName ??
    incomingState?.roleName ??
    incomingState?.name ??
    incomingState?.designation ??
    "";

  const dartsFormNeeded = incomingState?.dartsFormNeeded;
  const pocName = incomingState?.pocName;
  const pocEmail = incomingState?.pocEmail;
  const pocNumber = incomingState?.pocNumber;
  const numberLogin = incomingState?.numberLogin;
  const emailLogin = incomingState?.emailLogin;
  const mandatoryTimeDistribution =
    incomingState?.mandatoryTimeDistribution;
  const targetEditDays = incomingState?.targetEditDays;
  const inputEditDays = incomingState?.inputEditDays;
  const dartsNeeded = incomingState?.dartsNeeded;
  const clanNeeded = incomingState?.clanNeeded;
  const syncNeeded = incomingState?.syncNeeded;
  const geoTracking = incomingState?.geoTracking;
  const signInSignOutRequired =
    incomingState?.signInSignOutRequired;
  const locationRequired =
    incomingState?.locationRequired;
  const jobroleAccessUserIds =
    incomingState?.jobroleAccessUserIds;
  const ldmsNeeded = incomingState?.ldmsNeeded;
  const mirrorNeeded = incomingState?.mirrorNeeded;

  const fullState = {
    ...incomingState,

    roleId: safeRoleId,
    accountId: safeAccountId,
    accountName: safeAccountName,
    name: safeRoleName,
    roleName: safeRoleName,

    dartsNeeded:
      inputType !== null
        ? true
        : dartsNeeded ?? false,

    clanNeeded: clanNeeded ?? false,

    syncNeeded: syncNeeded ?? false,

    dartsFormNeeded:
      inputType !== null
        ? inputType === "Forms"
        : dartsFormNeeded ?? false,

    pocName: pocName ?? "",
    pocEmail: pocEmail ?? "",
    pocNumber: pocNumber ?? "",

    numberLogin: numberLogin ?? false,
    emailLogin: emailLogin ?? false,

    mandatoryTimeDistribution:
      mandatoryTimeDistribution ?? false,

    targetEditDays:
      targetEditDays ?? 0,

    inputEditDays:
      inputEditDays ?? 0,

    geoTracking:
      geoTracking ?? false,

    signInSignOutRequired:
      signInSignOutRequired ?? false,

    locationRequired:
      locationRequired ?? false,

    jobroleAccessUserIds:
      jobroleAccessUserIds ?? [],

    ldmsNeeded:
      ldmsNeeded ?? false,

    mirrorNeeded:
      mirrorNeeded ?? false,
  };

  useEffect(() => {
    console.log(
      "========== PRODUCTS CONFIGURATION =========="
    );

    console.log(
      "[ProductsConfiguration] Full incoming location.state:",
      incomingState
    );

    console.log(
      "[ProductsConfiguration] roleId:",
      safeRoleId
    );

    console.log(
      "[ProductsConfiguration] accountId:",
      safeAccountId
    );

    console.log(
      "[ProductsConfiguration] accountName:",
      safeAccountName
    );

    console.log(
      "[ProductsConfiguration] roleName:",
      safeRoleName
    );

    console.log(
      "[ProductsConfiguration] dartsNeeded:",
      dartsNeeded
    );

    console.log(
      "[ProductsConfiguration] clanNeeded:",
      clanNeeded
    );

    console.log(
      "[ProductsConfiguration] syncNeeded:",
      syncNeeded
    );

    console.log(
      "[ProductsConfiguration] fullState:",
      fullState
    );

    console.log(
      "=============================================="
    );
  }, [
    safeRoleId,
    safeAccountId,
    safeAccountName,
    safeRoleName,
    dartsNeeded,
    clanNeeded,
    syncNeeded,
  ]);

  const handleBackToExperience = () => {
    console.log(
      "[ProductsConfiguration] Going back to Experience Configuration with:",
      fullState
    );

    navigate("/experience-configuration", {
      state: fullState,
    });
  };

  return (
    <div
      className="min-h-screen bg-[#f5f5f5] pl-[44px] pr-[44px] pt-[90px]"
      style={{ minHeight: "calc(100vh + 90px)" }}
    >

      {/* Top Buttons */}
      <div className="flex justify-between items-start mb-6 ml-0">

        {/* Back */}
        <button
          onClick={handleBackToExperience}
          className="mt-4 flex items-center gap-2 bg-[#C21A17] text-white px-5 py-2 rounded-lg text-sm font-semibold shadow-md cursor-pointer"
        >
          <img
            src={BackIcon}
            alt="Back"
            className="w-[15px] object-contain transition-transform duration-300 hover:scale-105"
          />
          Back
        </button>

        {/* Home */}
        <button
          onClick={() => navigate("/admin")}
          className="mt-4 flex items-center gap-1 bg-[#C21A17] text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md cursor-pointer"
        >
          <img
            src={HomeIcon}
            alt="Home"
            className="w-[15px] object-contain transition-transform duration-300 hover:scale-105"
          />
          Home
        </button>

      </div>


      <div className="relative top-[-13px] flex items-center text-[14px] text-[#939393] ml-1">
        <span
          onClick={() => navigate("/admin")}
          className="cursor-pointer"
        >
          {safeAccountName}
        </span>

        <span className="mx-2 text-[14px]">
          ›
        </span>


        <span
          onClick={() => {
            console.log(
              "[ProductsConfiguration] Going to Dashboard with:",
              fullState
            );

            navigate("/dashboard", {
              state: fullState,
            });
          }}
          className="cursor-pointer"
        >
          {safeRoleName}
        </span>

        <span className="mx-2 text-[14px]">
          ›
        </span>

        <span
          onClick={() => {
            console.log(
              "[ProductsConfiguration] Going to Experience Configuration with:",
              fullState
            );

            navigate("/experience-configuration", {
              state: fullState,
            });
          }}
          className="cursor-pointer"
        >
          Experience Configuration
        </span>

        <span className="mx-2 text-[14px]">
          ›
        </span>

        {/* Current Page */}
        <span className="font-semibold text-gray-800">
          Products Configuration
        </span>
      </div>

      {/* Main Heading */}
      <h3 className="text-center text-[#b40000] text-[34px] font-bold tracking-[0.5px] leading-[42px] mb-4 mt-[30px]">
        Products Configuration
      </h3>

      {/* Sub Heading */}
      <p className="text-center text-[16px] font-semibold text-[#222] mb-12">
        Select The Product To Configure
      </p>

      {/* Products Grid */}
      <div className="grid grid-cols-2 gap-8 justify-center w-fit mx-auto mt-2">

        {/* LENSE */}
        <div className="bg-[#F2F2F2] h-[140px] w-[280px] overflow-hidden rounded-md border border-[#d9d9d9] flex items-center justify-center opacity-60 cursor-not-allowed shadow-sm">
          <img
            src={LenseImage}
            alt="Lense"
            className="w-[170px] object-contain pointer-events-none"
          />
        </div>

        {/* CLAN */}
        <div
          onClick={() => {
            console.log(
              "[ProductsConfiguration] Going to CLAN with:",
              fullState
            );

            navigate("/products-Configuration", {
              state: fullState,
            });
          }}
          className="bg-white h-[140px] w-[280px] overflow-hidden rounded-md border border-[#e4e4e4] flex items-center justify-center cursor-pointer shadow-sm hover:bg-[#FFF1F2] hover:border-[#F3C4C6] hover:shadow-md transition-all duration-200"
        >
          <img
            src={ClanImage}
            alt="Clan"
            className="w-[240px] h-[220px] object-contain transition-transform duration-300 hover:scale-105"
          />
        </div>

        {/* SYNC */}
        <div
          onClick={() => {
            console.log(
              "[ProductsConfiguration] Going to Sync Configuration with:",
              fullState
            );

            navigate("/sync-configuration", {
              state: fullState,
            });
          }}
          className="bg-white h-[140px] w-[280px] overflow-hidden rounded-md border border-[#e4e4e4] flex items-center justify-center cursor-pointer shadow-sm hover:bg-[#FFF1F2] hover:border-[#F3C4C6] hover:shadow-md transition-all duration-200"
        >
          <img
            src={SyncImage}
            alt="Sync"
            className="w-[170px] object-contain transition-transform duration-300 hover:scale-105"
          />
        </div>

        {/* MIRROR */}
        <div className="bg-[#F2F2F2] h-[140px] w-[280px] overflow-hidden rounded-md border border-[#d9d9d9] flex items-center justify-center opacity-60 cursor-not-allowed shadow-sm">
          <img
            src={MirrorImage}
            alt="Mirror"
            className="w-[170px] object-contain pointer-events-none"
          />
        </div>
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white w-[450px] rounded-[16px] shadow-xl p-5">

            <h2 className="text-[20px] font-semibold text-[#2B2B2B] ">
              Product Unavailable
            </h2>

            <p className="text-[16px] text-[#555555] mb-10">
              Do you need to give access to this product?
            </p>

            <div className="flex justify-end gap-4">

              <button
                onClick={() => setShowPopup(false)}
                className="w-[90px] h-[35px] border border-[#cf161c] text-[#cf161c] rounded-md text-[18px] font-medium"
              >
                No
              </button>

              <button
                onClick={() => setShowPopup(false)}
                className="w-[90px] h-[35px] bg-[#E10600] text-white rounded-md text-[18px] font-medium hover:bg-[#c70500] transition"
              >
                Yes
              </button>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ProductsConfiguration;